<div class="transcoding" *ngIf="mediaclipId && jobs">
	<div class="progressbar average" [ngClass]="{'complete': transcodingService?.getAverage(jobs) >= 1, 'warning': getErrors() > 0}">
		<div class="progress" style="width: 100%;">
			<span>{{transcodingService?.getAverage(jobs) * 100 | number: 0 }}% on {{jobs.length}} assets</span>
		</div>
	</div>
	<div *ngIf="transcodingService?.getAverage(jobs) < 1">
		<div *ngFor="let job of jobs" class="progressbar job" [ngClass]="{'success complete': job.status === 'transcoded', 'error': job.status === 'error'}">
			<div class="progress" [ngStyle]="getStylePercentage(job)">
				<span>{{transcodingService?.getPercentage(job) * 100 | number : 0}}% - {{job.mediaJobName}} {{ job.status }}</span>
			</div>
		</div>
	</div>
</div>